<template>
  <svg
    class="zonen"
    version="1.1"
    id="Ebene_1"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="enable-background: new 0 0 1000 1000"
  >
    <path
      class="zone"
      :class="zone == 'd' ? 'active' : ''"
      @click="selectZone('d')"
      data-id="d"
      data-zone="zone_d"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M699,301h259.8C908.4,184.9,815.1,91.6,699,41.2V301z"
    />

    <path
      class="zone"
      :class="zone == 'di' ? 'active' : ''"
      @click="selectZone('di')"
      data-id="di"
      data-zone="zone_di"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M1000,495c-0.6-65.1-13.7-127.1-36.9-184H796v184H1000z"
    />

    <rect
      :class="zone == 'dis' ? 'active' : ''"
      @click="selectZone('dis')"
      data-id="dis"
      data-zone="zone_dis"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="699"
      y="408"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'dic' ? 'active' : ''"
      @click="selectZone('dic')"
      data-id="dic"
      data-zone="zone_dic"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="699"
      y="311"
      width="87"
      height="87"
    />

    <path
      class="zone"
      :class="zone == 'ds' ? 'active' : ''"
      @click="selectZone('ds')"
      data-id="ds"
      data-zone="zone_ds"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M689,398v-87H602v49h-0.1l-91.1,91.2c18.9,4.2,33.8,19.1,38,38L640,398L689,398z"
    />

    <polygon
      :class="zone == 'dsi' ? 'active' : ''"
      @click="selectZone('dsi')"
      data-id="dsi"
      data-zone="zone_dsi"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="689,495 689,408 644.2,408 557.2,495 "
    />

    <polygon
      :class="zone == 'dsc' ? 'active' : ''"
      @click="selectZone('dsc')"
      data-id="dsc"
      data-zone="zone_dsc"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="505,442.9 592,355.9 592,311 505,311 "
    />

    <path
      class="zone"
      :class="zone == 'dc' ? 'active' : ''"
      @click="selectZone('dc')"
      data-id="dc"
      data-zone="zone_dc"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M505,0v204h184V36.9C632.1,13.7,570.1,0.6,505,0"
    />

    <rect
      :class="zone == 'dci' ? 'active' : ''"
      @click="selectZone('dci')"
      data-id="dci"
      data-zone="zone_dci"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="602"
      y="214"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'dcs' ? 'active' : ''"
      @click="selectZone('dcs')"
      data-id="dcs"
      data-zone="zone_dcs"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="505"
      y="214"
      width="87"
      height="87"
    />

    <path
      class="zone"
      :class="zone == 'i' ? 'active' : ''"
      @click="selectZone('i')"
      data-id="i"
      data-zone="zone_i"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M958.8,699H699v259.8C815.1,908.4,908.4,815.1,958.8,699"
    />

    <path
      class="zone"
      :class="zone == 'id' ? 'active' : ''"
      @click="selectZone('id')"
      data-id="id"
      data-zone="zone_id"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M1000,505H796v184h167.1C986.3,632.1,999.4,570.1,1000,505"
    />

    <rect
      :class="zone == 'ids' ? 'active' : ''"
      @click="selectZone('ids')"
      data-id="ids"
      data-zone="zone_ids"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="699"
      y="602"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'idc' ? 'active' : ''"
      @click="selectZone('idc')"
      data-id="idc"
      data-zone="zone_idc"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="699"
      y="505"
      width="87"
      height="87"
    />

    <path
      class="zone"
      :class="zone == 'is' ? 'active' : ''"
      @click="selectZone('is')"
      data-id="is"
      data-zone="zone_is"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M505,1000V796h184v167.1C632.1,986.3,570.1,999.4,505,1000"
    />

    <rect
      :class="zone == 'isd' ? 'active' : ''"
      @click="selectZone('isd')"
      data-id="isd"
      data-zone="zone_isd"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="602"
      y="699"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'isc' ? 'active' : ''"
      @click="selectZone('isc')"
      data-id="isc"
      data-zone="zone_isc"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="505"
      y="699"
      width="87"
      height="87"
    />

    <path
      class="zone"
      :class="zone == 'ic' ? 'active' : ''"
      @click="selectZone('ic')"
      data-id="ic"
      data-zone="zone_ic"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M602,689h87v-87.1h-49v-0.1l-91.2-91.1c-4.2,18.9-19.1,33.8-38,38L602,640L602,689z"
    />

    <polygon
      :class="zone == 'icd' ? 'active' : ''"
      @click="selectZone('icd')"
      data-id="icd"
      data-zone="zone_icd"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="557.1,505 644.1,591.9 689,591.9 689,505 "
    />

    <polygon
      :class="zone == 'ics' ? 'active' : ''"
      @click="selectZone('ics')"
      data-id="ics"
      data-zone="zone_ics"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="505,689 592,689 592,644.1 505,557.1 "
    />

    <path
      class="zone"
      :class="zone == 's' ? 'active' : ''"
      @click="selectZone('s')"
      data-id="s"
      data-zone="zone_s"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M41.2,699H301v259.8C184.9,908.4,91.6,815.1,41.2,699"
    />

    <path
      class="zone"
      :class="zone == 'sd' ? 'active' : ''"
      @click="selectZone('sd')"
      data-id="sd"
      data-zone="zone_sd"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M311,602v87h87.1v-49h0.1l91.1-91.2c-18.9-4.2-33.8-19.1-38-38L360,602L311,602z"
    />

    <polygon
      :class="zone == 'sdi' ? 'active' : ''"
      @click="selectZone('sdi')"
      data-id="sdi"
      data-zone="zone_sdi"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="495,557.1 408.1,644.1 408.1,689 495,689 "
    />

    <polygon
      :class="zone == 'sdc' ? 'active' : ''"
      @click="selectZone('sdc')"
      data-id="sdc"
      data-zone="zone_sdc"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="311,505 311,592 355.9,592 442.9,505 "
    />

    <path
      class="zone"
      :class="zone == 'si' ? 'active' : ''"
      @click="selectZone('si')"
      data-id="si"
      data-zone="zone_si"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M495,1000c-65.1-0.6-127.1-13.7-184-36.9V796h184V1000z"
    />

    <rect
      :class="zone == 'sid' ? 'active' : ''"
      @click="selectZone('sid')"
      data-id="sid"
      data-zone="zone_sid"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="408"
      y="699"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'sic' ? 'active' : ''"
      @click="selectZone('sic')"
      data-id="sic"
      data-zone="zone_sic"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="311"
      y="699"
      width="87"
      height="87"
    />

    <path
      class="zone"
      :class="zone == 'sc' ? 'active' : ''"
      @click="selectZone('sc')"
      data-id="sc"
      data-zone="zone_sc"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M0,505h204v184H36.9C13.7,632.1,0.6,570.1,0,505"
    />

    <rect
      :class="zone == 'scd' ? 'active' : ''"
      @click="selectZone('scd')"
      data-id="scd"
      data-zone="zone_scd"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="214"
      y="505"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'sci' ? 'active' : ''"
      @click="selectZone('sci')"
      data-id="sci"
      data-zone="zone_sci"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="214"
      y="602"
      width="87"
      height="87"
    />

    <path
      class="zone"
      :class="zone == 'c' ? 'active' : ''"
      @click="selectZone('c')"
      data-id="c"
      data-zone="zone_c"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M301,301H41.2C91.6,184.9,184.9,91.6,301,41.2V301z"
    />

    <path
      class="zone"
      :class="zone == 'cd' ? 'active' : ''"
      @click="selectZone('cd')"
      data-id="cd"
      data-zone="zone_cd"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M495,0c-65.1,0.6-127.1,13.7-184,36.9V204h184V0z"
    />

    <rect
      :class="zone == 'cdi' ? 'active' : ''"
      @click="selectZone('cdi')"
      data-id="cdi"
      data-zone="zone_cdi"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="408"
      y="214"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'cds' ? 'active' : ''"
      @click="selectZone('cds')"
      data-id="cds"
      data-zone="zone_cds"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="311"
      y="214"
      width="87"
      height="87"
    />

    <path
      class="zone"
      :class="zone == 'ci' ? 'active' : ''"
      @click="selectZone('ci')"
      data-id="ci"
      data-zone="zone_ci"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M398,311h-87v87.1h49v0.1l91.2,91.1c4.2-18.9,19.1-33.8,38-38L398,360L398,311z"
    />

    <polygon
      :class="zone == 'cid' ? 'active' : ''"
      @click="selectZone('cid')"
      data-id="cid"
      data-zone="zone_cid"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="495,311 408,311 408,355.9 495,442.9 "
    />

    <polygon
      :class="zone == 'cis' ? 'active' : ''"
      @click="selectZone('cis')"
      data-id="cis"
      data-zone="zone_cis"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      points="442.9,495 355.9,408.1 311,408.1 311,495 "
    />

    <path
      class="zone"
      :class="zone == 'cs' ? 'active' : ''"
      @click="selectZone('cs')"
      data-id="cs"
      data-zone="zone_cs"
      style="fill: rgba(65, 70, 77, 0.05)"
      d="M0,495c0.6-65.1,13.7-127.1,36.9-184H204v184H0z"
    />

    <rect
      :class="zone == 'csd' ? 'active' : ''"
      @click="selectZone('csd')"
      data-id="csd"
      data-zone="zone_csd"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="214"
      y="311"
      width="87"
      height="87"
    />

    <rect
      :class="zone == 'csi' ? 'active' : ''"
      @click="selectZone('csi')"
      data-id="csi"
      data-zone="zone_csi"
      class="zone"
      style="fill: rgba(65, 70, 77, 0.05)"
      x="214"
      y="408"
      width="87"
      height="87"
    />

    <path
      d="M511.9,511.8h6.2v-15c0-5.3-1.7-9.3-7.5-9.3c-2.9,0-6.1,1.3-7.5,4.2c-1.3-3-3.7-4.2-7-4.2   c-2.3,0-5.1,1-7.1,3.9h-0.1V488H483v23.8h6.2v-11.6c0-3.1,0.5-8,4.6-8c3.6,0,3.6,3.1,3.6,5.4v14.2h6.2v-11.6c0-3.1,0.5-8,4.6-8   c3.6,0,3.6,3.1,3.6,5.4v14.2H511.9z M532.6,500c0,18.1-14.6,32.6-32.6,32.6c-17.9,0-32.6-14.6-32.6-32.6s14.6-32.6,32.6-32.6   S532.6,482.1,532.6,500 M539.6,500c0-21.8-17.7-39.6-39.6-39.6c-21.8,0-39.6,17.7-39.6,39.6c0,21.8,17.7,39.6,39.6,39.6   C521.8,539.6,539.6,521.8,539.6,500"
      style="fill: #f02d1e"
    />
  </svg>
</template>

<script>
export default {
  props: {
    initialZone: {
      default: null,
    },
    selectable: {
      default: true,
    },
    forceEnabled: {
      default: false,
    },
  },

  data() {
    return {
      zone: this.initialZone,
    };
  },

  methods: {
    selectZone(zone) {
      if (!this.selectable || this.disabled)
        return false;

      this.zone = zone;

      this.$emit('selected', zone);
    },
  },

  computed: {
    disabled() {
      return !this.forceEnabled && !this.$page.props.auth.user.can.classifyWords;
    },
  },
};
</script>

<style scoped>
.active {
  fill: rgb(240, 45, 30) !important;
}
</style>